import axios from "axios";
import {
    setAccessToken,
    setCsrfToken,
    setRefreshToken,
    getRefreshToken,
} from "../tokenStore";
import { logoutApi } from "./LogoutApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Silently refresh the access token using the stored refresh token.
 * Called once on app boot before React renders.
 * If refresh fails (token expired/revoked), clears all tokens.
 * @returns {boolean} true if refresh succeeded, false otherwise
 */
export const silentRefresh = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return false;
    try {
        const response = await axios.post(
            `${BASE_URL}/web-auth/refresh`,
            { refreshToken },
            { withCredentials: true }
        );

        const result = response.data;

        if (result?.data?.accessToken) {
            setAccessToken(result.data.accessToken);
            setCsrfToken(result.data.csrfToken || "");
            if (result.data.refreshToken) {
                setRefreshToken(result.data.refreshToken);
            }
            return true;
        }

        logoutApi()
        return false;
    } catch {
        logoutApi()
        return false;
    }
};
